@if (banner && visible) {
  <aside class="d-sm-none app-banner-mobile-layer">
    <a
      (click)="close()"
      class="app-banner-mobile-layer__close bottom-fixed-banner-close text-center app-cursor m-2 d-block"
      >{{ 'web.close' | translate }}</a
      >
      @if (banner.url) {
        <a
          target="_blank"
          href="{{ banner.url }}{{ utm(banner.url) }}"
          [id]="bannerPositionId + ' | ' + banner.url"
          (click)="click()"
          class="app-banner-main"
          >
          <img
            src="{{ banner.path }}"
            class="banner"
            fetchpriority="high"
            alt="{{ banner.altText }}"
            style="width: 100%"
                srcset="{{ banner.small_image }} 600w,
                {{ banner.medium_image }} 1024w,
                {{ banner.large_image }} 1600w"
            />
        </a>
      } @else {
        @if (!banner.url) {
          <img
            src="{{ banner.path }}"
            class="banner"
            fetchpriority="high"
            alt="{{ banner.altText }}"
            style="width: 100%"
                srcset="{{ banner.small_image }} 600w,
                {{ banner.medium_image }} 1024w,
                {{ banner.large_image }} 1600w"
            />
        }
      }
    </aside>
  }
